import * as React from 'react'
import { SpreadsheetTableColumn, SpreadsheetTableLoadMetadata, SpreadsheetTableColumnId } from '../../../../table.types';

export type CellProps = {
  currentColumnWidth: number;
  className?: string;
  column: SpreadsheetTableColumn;
  loading: boolean;
  loadTableMetadata?: SpreadsheetTableLoadMetadata;
  onColumnResizeEnd: (columnId: SpreadsheetTableColumnId,  newColumnWidth: number, colName:string) => void;
  isFiltered?: boolean;
  onContextMenu?: (e: React.MouseEvent<HTMLTableCellElement>, columnId: SpreadsheetTableColumnId) => void;
};

export const useController = (props: CellProps) => {
  const { column, onColumnResizeEnd, onContextMenu, currentColumnWidth } = props; // ← Add onContextMenu
  const [temporaryColumnWidth, setTemporaryColumnWidth] = React.useState(currentColumnWidth);
  const [resizingColumn, setResizingColumn] = React.useState<boolean>(false);
  const startWidthRef = React.useRef<number>(currentColumnWidth);

  const handleMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    setResizingColumn(true);

    const startX = event.clientX;
    // Use the currentColumnWidth prop as the baseline
    startWidthRef.current = currentColumnWidth;
    let newWidth = startWidthRef.current;

    const handleMouseMove = (e: MouseEvent) => {
      newWidth = startWidthRef.current + (e.clientX - startX);
      setTemporaryColumnWidth(newWidth);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove as unknown as EventListener);
      document.removeEventListener('mouseup', handleMouseUp);

      setResizingColumn(false);
      onColumnResizeEnd(column.id, newWidth, column.colName);
    };

    document.addEventListener('mousemove', handleMouseMove as unknown as EventListener);
    document.addEventListener('mouseup', handleMouseUp);
  };

  // Add context menu handler
  const handleContextMenu = React.useCallback((e: React.MouseEvent<HTMLTableCellElement>) => {
    if (onContextMenu) {
      onContextMenu(e, column.id);
    }
  }, [onContextMenu, column.id]);

  const resizerOffset = temporaryColumnWidth - currentColumnWidth;

  return {
    resizerOffset,
    resizingColumn,
    handleMouseDown,
    handleContextMenu: onContextMenu ? handleContextMenu : undefined, // ← Return the handler
  };
};